<template>
  <div class="page-work-list">
    <work-list :works="list"
               :next-start="start"
               :query="query"
    />
  </div>
</template>

<script>
  import { getWorkList } from '@/services/work';
  import { LIMIT } from '@/utils/constant';
  import WorkList from '@/pages/Work/components/WorkList';

  export default {
    name: 'PageWorkList',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      WorkList,
    },
    data() {
      return {
        start: 0,
        list: [],
        render: {
          pageTitle: '作品列表',
        },
        query: null,
      };
    },
    methods: {
      async fetchData() {
        const { query, start } = this;
        const params = Object.assign({
          limit: LIMIT,
          start,
        }, query);
        const data = await getWorkList(params);

        this.list = data.list;
        this.start = data.start;
        this.render = data.render;
      },
    },
    created() {
      const { query } = this.$route;
      this.query = query;
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .work-list {
    background-color: @color-white;
  }
</style>
